//#region imports
import { Globals } from './../../../../services/globals';
import { SaveAddressModel } from './../../model/signature.model';
import { SignatureService } from 'src/app/services/signature.service';
import { Component, OnInit } from '@angular/core';
import { SectionService } from 'src/app/services/section.service';
import { P5xService } from 'src/app/services/p5x.service';
import { CharacteristicService } from 'src/app/services/characteristic.service';
//#endregion

@Component({
  selector: 'app-signature-question2',
  templateUrl: './signature-question2.component.html',
  styleUrls: ['./signature-question2.component.css']
})
export class SignatureQuestion2Component implements OnInit {
  //#region variables
  postalCode: number;
  location: string;
  mobilePostalLocation: string;
  address: string;
  direction: string;
  box: string;
  data: any;
  copyAddress: boolean;
  signatureSaveList: SaveAddressModel;
  signatureData: any;
  isSecondaryResidence: boolean = false;
  isCustomer: boolean = false;
  //#endregion

  //#region methods
  constructor(
    private signatureService: SignatureService, private globals: Globals,
    private sectionService: SectionService, private p5xService: P5xService, 
    private characteristicservice: CharacteristicService) { }

  ngOnInit() {
    this.sectionService.setCurrentPage('P5-2');
    this.globals.trackPageActivity += ';' + 'P5-2';
    this.signatureData = JSON.parse(sessionStorage.getItem('signatureData'));
    this.isSecondaryResidence = this.p5xService.getSecondaryResidence();
    this.isCustomer = this.characteristicservice.getClientIdOrSimulationTokenPresent();
    this.setData();
    this.globals.quesWarning = false;
  }

  setData() {
    // this.copyAddress = this.signatureData.Copy_Address != null ? this.signatureData.Copy_Address : true;
    if (this.isCustomer == true || this.isSecondaryResidence == true)
    {
      if(this.signatureData.Copy_Address == true)
      {
        //do nothing
      }
      else{
        this.signatureData.Copy_Address = false;
      }
    }
    
    this.copyAddress = this.signatureData.Copy_Address != null ? this.signatureData.Copy_Address : true;

    this.signatureData.Copy_Address = this.copyAddress;
    const data = JSON.parse(sessionStorage.getItem('jsonData'));
    const section = data.Sections.find(obj => obj.SectionKey === 'S2.1');
    const sectionKey = section != null ? 'S2.1' : 'S2.2';
    if (sectionKey === 'S2.1') {
      const code = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G9').
        Questions.find(obj => obj.QuestionKey === 'House_Property_Post_Code_Question').Answers;
      this.postalCode = code != null ? code[0].AnswerText : '';

      const location = data.Sections.find(obj => obj.SectionKey === 'S2.1').
        QuestionGroup.find(obj => obj.GroupKey === 'G9').
        Questions.find(obj => obj.QuestionKey === 'House_Property_Post_Code_Place_Question').Answers;

      this.location = location[0].AnswerText;
      this.signatureData.Property_Address_Post_Code = this.postalCode;
      this.signatureData.Property_Address_Place = this.location;
    } else {
      const code = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G15').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Question').Answers;
      this.postalCode = code != null ? code[0].AnswerText : '';

      const location = data.Sections.find(obj => obj.SectionKey === 'S2.2').
        QuestionGroup.find(obj => obj.GroupKey === 'G15').
        Questions.find(obj => obj.QuestionKey === 'Apartment_Property_Post_Code_Place_Question').Answers;

      this.location = location[0].AnswerText;
      this.signatureData.Property_Address_Post_Code = this.postalCode;
      this.signatureData.Property_Address_Place = this.location;
    }
    this.mobilePostalLocation = this.postalCode + ' - ' + this.location;
    this.globals.propertyPostCode = this.signatureData.Property_Address_Post_Code;
    this.address = this.signatureData.Property_Address_Street;
    this.direction = this.signatureData.Property_Address_Street_Number;
    this.box = this.signatureData.Property_Address_Box;
    sessionStorage.setItem('signatureData', JSON.stringify(this.signatureData));
  }

  modelChanged(choice, enteredValue) {
    this.mapAnswer(choice, enteredValue);
  }

  isNumber(evt, code) {
    if (code === 0) {
      evt = (evt) ? evt : window.event;
      evt.preventDefault();
    } else {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((code.length > 14) || (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode != 43))) {
        evt.preventDefault();
      } else if (charCode === 107) {
        return true;
      } else {
        return true;
      }
    }
  }

  selectedAnswer(choice, event) {
    this.mapAnswer(choice, event.target.checked);
  }

  mapAnswer(selectedChoice, selectedText) {
    const jsonData = sessionStorage.getItem('signatureData');
    const data = JSON.parse(jsonData);
    const saveAddress = this.signatureService.getSaveAddress1();
    switch (selectedChoice) {
      case 'Property_Address_Street':
        data.Property_Address_Street = selectedText;
        saveAddress.Property_Address_Street = selectedText;
        break;
      case 'Property_Address_Street_Number':
        data.Property_Address_Street_Number = selectedText;
        saveAddress.Property_Address_Street_Number = selectedText;
        break;
      case 'Property_Address_Box':
        data.Property_Address_Box = selectedText;
        saveAddress.Property_Address_Box = selectedText;
        break;
      case 'Copy_Address':
        data.Copy_Address = selectedText;
        saveAddress.Copy_Address = selectedText;
        if(selectedText === false){
          data.Taker_Address_Post_Code = '';
          data.Taker_Address_Street = '' ;
          data.Taker_Address_Street_Number = '';
          data.Taker_Address_Box = '';}
        break;
    }
    this.signatureService.setSaveAddress1(saveAddress);
    sessionStorage.setItem('signatureData', JSON.stringify(data));
  }

  setDataToStorage() {
    this.signatureService.getData().subscribe((data) => {
      this.data = data;
    });
  }
  //#endregion
}
